const store = typeof window !== 'undefined' ? window.localStorage : null;

export default store;
